enum actionType {
    CHANGE_PASSWORD_START='CHANGE_PASSWORD_START',
    CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED',
  }
  
  export default actionType;
  